module.exports = "Describe how you propose to solve the problem and provide code samples of how the API would work once implemented. Note that you can use [Markdown](https://guides.github.com/features/mastering-markdown/) to format your code blocks.\n"


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/en/proposalHelp.md
// module id = 495
// module chunks = 0